export default __webpack_public_path__ + "static/media/termRise.a93e05aa.svg";